import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetQuoteImportStatusV1Response } from './get-quote-import-status-v1-response';
import { getQuoteImportStatusV1ResponseSchema } from './get-quote-import-status-v1-response';

export async function getQuoteImportStatusV1Api(
  collectionId: number,
): Promise<IValidatedResponse<IGetQuoteImportStatusV1Response>> {
  return getRequest<IGetQuoteImportStatusV1Response>({
    path: `/sys/quotes/v1/collections/${collectionId}/status`,
    schema: getQuoteImportStatusV1ResponseSchema,
  });
}
